import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { BusinessPartnerPicker } from 'modules/Shared/Components/BusinessPartner/BusinessPartnerPicker';
import { UnitDataFormTypes } from 'modules/Shared/State/unit';

type ManufacturedBySectionProps = {
	manufacturerName: string | null;
};

export const ManufacturedBySection = ({
	manufacturerName,
}: ManufacturedBySectionProps) => {
	const { control } = useFormContext<UnitDataFormTypes>();
	const { t } = useTranslation(['unitOverview']);

	return (
		<Box
			component={Paper}
			variant="flatGrey"
			sx={{
				display: 'grid',
				gridTemplateColumns: {
					xs: 'repeat(1, 1fr)',
					sm: 'repeat(2, 1fr)',
					md: 'repeat(4, 1fr)',
				},
				gap: 2,
				p: 2,
			}}>
			<Box
				sx={{
					gridColumn: { sm: 'span 2', md: '1' },
					gridRow: '1/3',
				}}>
				<Typography variant="h3" sx={{ pb: 1 }}>
					{t('unitOverview:oem-data-section')}
				</Typography>
			</Box>
			<BusinessPartnerPicker<UnitDataFormTypes>
				id="manufactured-by-picker"
				control={control}
				name="manufacturerParmaId"
				label={t('unitOverview:overview-manufactured-by')}
				initialInputValue={manufacturerName ?? ''}
				size="small"
			/>
		</Box>
	);
};
